import React, { PureComponent } from 'react';
import { isEqual } from 'lodash';
import { addMarker, googleMarkerIcon, zoomMap } from './mapUtils';
import { middleOfTheWorld } from '../../types/orderTypes';

export interface MarkerIcon {
  info?: any;
  type?: string;
  backgroundColor?: string;
  color?: string;
  label?: string;
  stroke?: boolean;
}

export interface Marker {
  icon: MarkerIcon;
  lat: number;
  lng: number;
}

interface Props {
  markers: Marker[];
  height: number | string;
  width: string;
}

export default class Map extends PureComponent<Props> {
  private markers: google.maps.Marker[] = [];
  private mapContainer: Element;
  private map: google.maps.Map;
  private infoWindow: google.maps.InfoWindow;

  static defaultProps = { height: 500, width: '100%' };

  componentDidMount() {
    this.map = new google.maps.Map(this.mapContainer, {
      zoom: 11,
      clickableIcons: true,
      center: middleOfTheWorld,
      disableDefaultUI: true,
      mapTypeControl: false,
      zoomControl: true,
      maxZoom: 16,
    });

    this.infoWindow = new google.maps.InfoWindow();
    this.map.addListener('click', () => {
      this.infoWindow.close();
    });

    new google.maps.TrafficLayer().setMap(this.map);
  }

  componentDidUpdate(prevProps: Readonly<Props>) {
    if (this.props.markers && !isEqual(this.props.markers, prevProps.markers)) {
      this.addMarkers();
    }
  }

  addMarkers = () => {
    const newMarkers = this.props.markers;

    this.markers.forEach(marker => marker.setMap(null));
    this.markers = [];

    newMarkers.forEach(marker => {
      const markerInfo =
        marker.icon && marker.icon.info ? marker.icon.info : null;
      this.markers.push(
        addMarker({
          position: {
            lat: marker.lat,
            lng: marker.lng,
          },
          icon: marker.icon && googleMarkerIcon(marker.icon),
          map: this.map,
          addInfoWindow: markerInfo,
          info: markerInfo,
          infoWindow: this.infoWindow,
        })
      );
    });
    zoomMap(this.markers, this.map);
  };

  render() {
    const { width, height } = this.props;
    return (
      <div
        ref={node => {
          this.mapContainer = node;
        }}
        style={{ height, width }}
      />
    );
  }
}
